import { render, staticRenderFns } from "./HeadlinesBlock.vue?vue&type=template&id=673f77ad&scoped=true"
import script from "./HeadlinesBlock.vue?vue&type=script&lang=ts"
export * from "./HeadlinesBlock.vue?vue&type=script&lang=ts"
import style0 from "./HeadlinesBlock.vue?vue&type=style&index=0&id=673f77ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f77ad",
  null
  
)

export default component.exports